module.exports = __webpack_public_path__ + "media/images/svg/layout-2b03c4ec3ed4c287cc31b91f8b7d0560.svg";